module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE FAR REACHES")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("To Linda, my island girl, and Carl, who has shared many an adventure, and his father, who waded across that awful lagoon"), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0